'use client'
import { useEffect, useState } from 'react';
import { ServiceCoursesProvider } from 'api/ServiceCoursesProvider';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from 'contexts/LanguageContext';
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import Spinner from 'components/spinner';
import { Link } from '@fluentui/react/lib/Link';
import { DetailsList, DetailsListLayoutMode, SelectionMode, IColumn } from '@fluentui/react/lib/DetailsList';

export default function Registrations() {
    const {lang, res} = useLanguage();
    const navigate = useNavigate();
    const msal = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const [registrations, setRegistrations] = useState<any[]>([]);
    const [registrationsLoading, setRegistrationsLoading] = useState(false);
    const _columns: IColumn[] = [
        { key: 'column1', name: res["Session"], fieldName: 'titre', minWidth: 100, maxWidth: 450, isResizable: true,
            onRender: (item) => (
                // eslint-disable-next-line react/jsx-no-bind
                <Link key={item.id} onClick={() => navigate(`/${lang}/courses/${item.idSession}`)} underline>
                    {item.titre}
                </Link>
            )
        },
        { key: 'column2', name: res["Début (Formation)"], fieldName: 'debut', minWidth: 100, maxWidth: 150, isResizable: true },
        { key: 'column3', name: res["Duree"], fieldName: 'duree', minWidth: 100, maxWidth: 150, isResizable: true },
        { key: 'column4', name: res["Formateur"], fieldName: 'formateur', minWidth: 100, maxWidth: 150, isResizable: true }
    ];

    useEffect(() => {
        setRegistrationsLoading(true);
        const getregistrations = async function() {
            const fetchedRegistrations = await ServiceCoursesProvider.provider.getRegistrations(msal, lang);
            const registrationsToUse: any[] = [];
            if (fetchedRegistrations) {
                fetchedRegistrations.forEach((p: any) => {
                    const startDate = new Date(p.debut);
                    registrationsToUse.push({
                        id: p.id,
                        idSession : p.idSession,
                        titre: p.titre[lang],
                        debut: startDate.toLocaleString(lang+"-CA", {dateStyle: 'short',timeStyle: 'short',}),
                        duree: p.duree,
                        formateur: p.formateur ?? ""
                    });
                });
            }
            setRegistrations(registrationsToUse);
            setRegistrationsLoading(false);
        }
        if (isAuthenticated) {
            getregistrations();
        }
    }, [isAuthenticated]);

    return (
        <div className="mx-auto">
            <h3 className="h3 mb-4 aos-init aos-animate">{res["Inscriptions"]}</h3>
            {(registrationsLoading) ? (
                <div className="mh300">
                    <Spinner />
                </div>
            ) : (
                <DetailsList
                    items={registrations}
                    columns={_columns}
                    setKey="set"
                    layoutMode={DetailsListLayoutMode.justified}
                    selectionMode={SelectionMode.none}
                />
            )}
        </div>
    );
}
